import React, { useState } from "react";
import styles from "./SelectStatus.module.css";
import { MenuItem, Select } from "@mui/material";
function SelectStatus({ setStatusValue, statusValue }) {
  const [optionValue, setOptionValue] = useState(["Pending", "Failed", "Paid"]);

  const handleStatusChange = async (newStatus) => {
    setStatusValue({
      status: newStatus,
    });
  };
  return (
    <div>
      <Select
        labelId="status-select-label"
        value={statusValue.status}
        onChange={(e) => handleStatusChange(e.target.value)}
        size="small"
        sx={{
          width: "100%",
          borderRadius: "15px",
          border: "none",
          fontSize: "11px",
          fontWeight: "500",
        }}
        className={
          statusValue?.status === "Pending"
            ? styles.pending
            : statusValue?.status === "Failed"
            ? styles.statusFailed
            : statusValue?.status === "Paid"
            ? styles.statusPaid
            : ""
        }
      >
        {optionValue?.map((item) => (
          <MenuItem key={item} value={item}>
            {item}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
}

export default SelectStatus;
